import { render } from "./MyProducts.vue?vue&type=template&id=25edabd3"
import script from "./MyProducts.vue?vue&type=script&lang=js"
export * from "./MyProducts.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./MyProducts.vue?vue&type=style&index=0&id=25edabd3&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__